import React from "react";

import apple from "assets/graphics/icons/apple--white.svg";
import android from "assets/graphics/icons/android--white.svg";

import "features/application/download/view.scss";

const DownloadView = () => (
  <div className="download__content">
    <h1 className="application__headline">Congrats!</h1>
    <p className="form__description--large">
      You just completed setting up your Parlor Social Club account and now you
      can use this to login to the APP.
    </p>
    <div className="download__stores">
      <a
        className="download__store"
        href="https://apps.apple.com/us/app/parlor-social-club/id1473428896"
        target="blank"
        onClick={() => window.dataLayer.push({ event: "iosVisited" })}
      >
        <img src={apple} alt="apple" />
      </a>
      <a
        className="download__store"
        href="https://play.google.com/store/apps/details?id=social.parlor.app"
        target="blank"
        onClick={() => window.dataLayer.push({ event: "androidVisited" })}
      >
        <img src={android} alt="android" />
      </a>
    </div>
  </div>
);

export default DownloadView;
